//similar to vehicle VehicleMarkerDot component, check possibility to unify them
export const BlackDot = () => (
  <div
    css={theme => ({
      width: 10,
      height: 10,
      backgroundColor: theme.semantic.ColorContentDefault,
      border: `1px solid ${theme.semantic.ColorSurfaceDefault}`,
      borderRadius: '100%',
      boxShadow: '1px 1px 2px 0px rgba(0, 0, 0, 0.25)',
    })}
  />
)
